import React from "react";
import { Link } from "react-router-dom";
import "./VideoStyles.css";
import MatrixVideo from "../assets/ecls2-new_3.mp4";

const Video = () => {
  return (
    <div className="hero">
      <video autoPlay loop muted playsInline id="video">
        <source src={MatrixVideo} type="video/mp4" />
      </video>
      <div className="content">
        <h1>East Coast Landscapes</h1>
        <p>"Bringing the East Coast to you!"</p>
        <div>
          <Link to="/services" className="btn btn-light">
            Services
          </Link>
          <Link to="/contact" className="btn">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Video;
